<div id="topMenuWrap">
  <app-banner *ngIf="viewConfigurations.showBannersDesktop"></app-banner>
  <app-results-navigation [isLive]="false" *ngIf="viewConfigurations.showFilterNavigationMenu"></app-results-navigation>
</div>
<div class="content-wrap" [class.contentV2]="viewConfigurations.useMobileViewWithTopMenu">
  <section class="left-content-wrap">
    <div id="leftContent">
      <app-results-sports-tree></app-results-sports-tree>
    </div>
  </section>

  <section class="center-content-wrap result">
    <div id="centerContent">
      <app-results-sports-selection-container [class.hide]="expandedEventResult"></app-results-sports-selection-container>
      <app-results-event-details *ngIf="expandedEventResult" [expandedEventResult]="expandedEventResult"></app-results-event-details>

    </div>
  </section>
</div>

<app-loader [class.hide]="!loading"></app-loader>
